export const deepLinkUrl = "https://ui.sharpsports.io/place/parlay/"